/**
 * Avatar — animated SVG humanoid avatars from DiceBear (no real faces).
 *
 * Deterministic — same seed → same avatar. Use email or name as seed so a
 * user's avatar stays consistent across the app without storing anything.
 *
 * Style "adventurer-neutral" — illustrated, friendly, gender-agnostic, lime-tinted bg.
 * Fully cacheable PNG-equivalent SVG, ~3KB per avatar, no auth.
 */
import React from "react";

const palette = ["8CFF2E", "A78BFA", "60A5FA", "F472B6", "FCD34D", "34D399"];

const Avatar = ({ src, seed, name, size = 40, className = "", testid }) => {
  // If a real picture URL is present, use it; otherwise build a DiceBear avatar.
  if (src) {
    return (
      <img
        src={src}
        alt={name || "avatar"}
        loading="lazy"
        data-testid={testid}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
      />
    );
  }
  const key = (seed || name || "guest").toLowerCase().replace(/\s+/g, "-");
  // Pick a deterministic background colour from the palette.
  const bg = palette[Math.abs(Array.from(key).reduce((a, c) => a + c.charCodeAt(0), 0)) % palette.length];
  const url = `https://api.dicebear.com/9.x/adventurer-neutral/svg?seed=${encodeURIComponent(key)}&radius=50&backgroundColor=${bg}&backgroundType=gradientLinear`;
  return (
    <img
      src={url}
      alt={name || "avatar"}
      loading="lazy"
      data-testid={testid}
      className={`rounded-full border border-[#27272A] ${className}`}
      style={{ width: size, height: size, background: "#15161A" }}
    />
  );
};

export default Avatar;
